import { render, staticRenderFns } from "./ConfigurationSidebar.vue?vue&type=template&id=7eadd4f4&scoped=true&"
import script from "./ConfigurationSidebar.vue?vue&type=script&lang=js&"
export * from "./ConfigurationSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eadd4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eadd4f4')) {
      api.createRecord('7eadd4f4', component.options)
    } else {
      api.reload('7eadd4f4', component.options)
    }
    module.hot.accept("./ConfigurationSidebar.vue?vue&type=template&id=7eadd4f4&scoped=true&", function () {
      api.rerender('7eadd4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product/components/ConfigurationSidebar.vue"
export default component.exports